import { Dispatch, useState } from 'react';
import { Button } from '@mui/material';
import CustomDialog from '@/components/Dialog/CustomDialog';
import HPODataList from './HPODataList';

interface BtnMenuHPOProps {
  setOpen: Dispatch<React.SetStateAction<boolean>>;
}

const BtnMenuHPO = ({ setOpen }: BtnMenuHPOProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const handleCreate = () => {
    setAnchorEl(null);
    setOpen(true);
    // handleAddHPOClick();
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <div>
      <Button
        size="small"
        variant="outlined"
        id="fade-button"
        aria-controls={menuOpen ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? 'true' : undefined}
        onClick={handleCreate}
      >
        Browse HPO
      </Button>
      {/* <Button
        variant="contained"
        id="fade-button"
        aria-controls={menuOpen ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? 'true' : undefined}
        onClick={handleClick}
      >
        Add HPO
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handleSelect}>Select HPO</MenuItem>
        <MenuItem onClick={handleCreate}>HPO API</MenuItem>
      </Menu> */}
      <CustomDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onSubmit={() => {
          console.log('test');
        }}
        title="HPO"
      >
        <HPODataList />
        {/* // handleConfirmClick={handleConfirmClick} */}
        {/* setDialogOpen={setDialogOpen} */}
      </CustomDialog>
    </div>
  );
};

export default BtnMenuHPO;
